import React from 'react';
export const TopBar = () => {
  return null;
};